import React from 'react';
import { SectionReveal } from './SectionReveal';
interface TestimonialCardProps {
  name: string;
  location: string;
  photo: string;
  quote: string;
  result: string;
  delay?: number;
}
export function TestimonialCard({
  name,
  location,
  photo,
  quote,
  result,
  delay = 0
}: TestimonialCardProps) {
  return <SectionReveal delay={delay} data-id="element-97">
      <div className="bg-white rounded-3xl p-8 shadow-xl shadow-pink-100/50 flex flex-col items-center text-center h-full border border-blush/50 hover:-translate-y-1 transition-transform duration-300" data-id="element-98">
        <div className="relative mb-6" data-id="element-99">
          <div className="absolute inset-0 bg-rosegold rounded-full blur-md opacity-20 transform translate-y-2" data-id="element-100"></div>
          <img src={photo} alt={name} className="relative w-24 h-24 rounded-full object-cover border-2 border-white shadow-md" data-id="element-101" />
        </div>
        <h4 className="font-serif text-xl text-navy mb-1" data-id="element-102">{name}</h4>
        <p className="text-xs font-bold tracking-widest text-rosegold uppercase mb-6" data-id="element-103">
          {location}
        </p>
        <p className="text-navy/70 italic mb-8 flex-grow leading-relaxed" data-id="element-104">
          "{quote}"
        </p>
        <div className="bg-blush-light px-6 py-3 rounded-full w-full border border-blush" data-id="element-105">
          <p className="text-sm font-semibold text-rosegold" data-id="element-106">{result}</p>
        </div>
      </div>
    </SectionReveal>;
}